interface ProgressBarAlertProps {
  currentProgress: number;
  totalProgress: number;
  color: string;
  showProgressText?: boolean;
  progressText?: string;
}

export const progressBarSwalAlert = ({ currentProgress, totalProgress, color, showProgressText = false, progressText = "" }: ProgressBarAlertProps): string => {
  if (currentProgress === 0 && totalProgress === 0) {
    return `
      <div style="text-align: center;">
        ${showProgressText ? '<div>Progresso: <span id="progress-text">Aguarde...</span></div>' : ''}
        <div style="width: 100%; background: #f0f0f0; border-radius: 5px; margin-top: ${showProgressText ? '10px' : '0'};">
          <div id="progress-bar" style="width: 100%; height: 20px; background: ${color}; border-radius: 5px; transition: width 0.3s ease-in-out; position: relative;">
            <span style="position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%); color: white; font-size: 12px; font-weight: bold;">
              Carregando...
            </span>
          </div>
        </div>
      </div>
    `;
  }

  const percentage = Math.round((currentProgress / totalProgress) * 100);
  return `
      <div style="text-align: center;">
        ${showProgressText ? progressText ? `<div><span id="progress-text">${progressText}</span></div>` : `<div>Progresso: <span id="progress-text">${currentProgress}/${totalProgress}</span></div>` : ''}
        <div style="width: 100%; background: #f0f0f0; border-radius: 5px; margin-top: ${showProgressText ? '10px' : '0'}; position: relative;">
          <div id="progress-bar" style="width: ${percentage}%; height: 20px; background: ${color}; border-radius: 5px; transition: width 0.3s ease-in-out;">
          </div>
          <span style="position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%); color: ${percentage >= 50 ? 'white' : 'black'}; font-size: 12px; font-weight: bold;">
            ${percentage}%
          </span>
        </div>
      </div>
  `;
};